import { Divider, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { styles } from '../../styles';

const { Title, Paragraph } = Typography;

export default function BlogFooter() {
  return (
    <>
      <Divider />
      <Paragraph style={{ ...styles.blogParagraph, fontSize: '13px', opacity: 0.85 }}>
        Editorial note: This article is original commentary by Koostream. Facts about public
        sporting events are reported for news and analysis. Images are used for editorial
        illustration. Rights holders may request removal through our{' '}
        <Link to="/dmca">DMCA Policy</Link>.
      </Paragraph>
      <Title level={4} style={{ ...styles.blogHeading, textAlign: 'center' }}>
        See today’s sports fixtures on the <Link to="/">Koostream homepage</Link>.
      </Title>
    </>
  );
}
